import { Injectable } from '@angular/core';
import { ID, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { NewTag, Tag, TagResponse } from './tags.model';
import { Acct } from '../../../shared/state/accts/acct.model';
import * as PleaseJS from 'pleasejs/dist/Please.js';
// @ts-ignore
import { Please } from 'pleasejs';
import { PrivateEquityPerformance } from '../../private-equity-performance/state/private-equity-performance.model';

export interface TagState extends EntityState<TagResponse, string> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'new-tags' })
export class TagsStore extends EntityStore<TagState> {
    constructor() {
        super();
    }

    akitaPreAddEntity(tag: TagResponse) {
        tag = {
            ...tag,
            title: tag.value
        };
        return tag;
    }

    akitaPreUpdateEntity(prevTag: TagResponse, tag: TagResponse) {
        tag = {
            ...tag,
            title: tag.value
        };
        return tag;
    }
}

export function createNewTag(
    params: Omit<NewTag, 'createdDate' | 'id'> & {
        accountId?: Acct['accountId'];
    }
) {
    const { accountId, ...tagProperties } = params;
    if (accountId) {
        tagProperties.accountIds = [accountId];
    }
    return {
        ...tagProperties,
        createdDate: new Date(),
        id: btoa(encodeURIComponent(params.title))
    } as NewTag;
}

export function mergeTags(tags: Array<TagResponse>) {
    const tagMap = new Map<string, Tag>();
    tags.forEach((tag, index) => {
        const existingTag = tagMap.get(tag.value);
        const itemType = tag.itemType;
        if (existingTag) {
            existingTag._tags = { ...existingTag._tags, [tag.id]: tag };
            switch (itemType) {
                case 'account':
                case 'instrument':
                case 'transaction':
                    existingTag[itemType] = {
                        ...(existingTag[itemType] || {}),
                        [+tag.itemId]: tag
                    };
                    break;
                case 'journalEntry':

                case 'document':
                    existingTag[itemType] = {
                        ...(existingTag[itemType] || {}),
                        [tag.itemId]: tag
                    };
                    break;
            }
        } else {
            const groupColor = PleaseJS.make_scheme({
                h: 130,
                s: 0.7,
                v: 0.75
                //set base color
            });

            tagMap.set(tag.value, {
                //...extractTagGroupAndTitle(tag),
                description: tag.description,
                color: tag.color,
                title: tag.title,
                group: tag.group,
                order: tag.order,
                createdAt: tag.createdAt,
                createdBy: tag.createdBy,
                updatedAt: tag.updatedAt,
                updatedBy: tag.updatedBy,
                _tags: { [tag.id]: tag },
                //hexColor: groupColor[index],
                [itemType]:
                    itemType !== 'document' && itemType !== 'journalEntry'
                        ? { [+tag.itemId]: tag }
                        : { [tag.itemId]: tag }
            });
        }
    });
    return Array.from(tagMap.values());
}

export function extractTagGroupAndTitle(tag: TagResponse): Pick<Tag, 'title' | 'group'> {
    const title = tag.value.split('@')[1] || tag.value;
    const group = tag.value.split('@')[1] ? tag.value.split('@')[0] : null;
    return { title, group };
}

export function extractTagPropertiesFromTitle(
    string: TagResponse['title']
): Pick<TagResponse, 'title' | 'group' | 'order'> {
    let title = string.split('@')[1] || string;
    const group = string.split('@')[1] ? string.split('@')[0] : null;
    const hasOrder = title.split('#')[1];
    let order = null;
    if (hasOrder && !isNaN(+title.split('#')[0])) {
        order = +title.split('#')[0];
        title = title.split('#')[1];
    }

    return { title, group, order };
}
